import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useEffect, useState } from "react";
import { useWithdraws } from "../../store/useWithdraws";
import { WithdrawFilters } from "./WithdrawFilters";
import { WithdrawTable } from "./WithdrawTable";
import { WalletStatsCards } from "../../components/wallet/WalletStatsCards";

function WithdrawsScreen() {
  /** Hooks */
  const {
    getAllWithdraws,
    allWithdraws,
    hasNextPage,
    getWalletStats,
    walletStats,
    isWalletStatsLoading,
  } = useWithdraws();
  /** State */
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");
  const [dayFilter, setDayFilter] = useState<number | undefined>(undefined);
  const [monthFilter, setMonthFilter] = useState<number | undefined>(undefined);
  const [yearFilter, setYearFilter] = useState<number | undefined>(undefined);

  useEffect(() => {
    getAllWithdraws(page, 20, status, dayFilter, monthFilter, yearFilter);
    getWalletStats();
  }, [
    getAllWithdraws,
    getWalletStats,
    page,
    status,
    dayFilter,
    monthFilter,
    yearFilter,
  ]);

  const handleApplyFilters = (filters: {
    status?: string;
    day?: number;
    month?: number;
    year?: number;
  }) => {
    setStatus(filters.status ?? "");
    setDayFilter(filters.day);
    setMonthFilter(filters.month);
    setYearFilter(filters.year);
    setPage(1); // Reset to first page when filters change
  };

  const handleClearFilters = () => {
    setStatus("");
    setDayFilter(undefined);
    setMonthFilter(undefined);
    setYearFilter(undefined);
    setPage(1); // Reset to first page when filters clear
  };

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Payments
        </h1>
      </div>

      <WalletStatsCards
        walletStats={walletStats}
        isLoading={isWalletStatsLoading}
      />

      <WithdrawFilters
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
      />

      {allWithdraws?.length && <div className="mb-11"></div>}
      <div className="w-full px-7 py-7 bg-white  border-gray-border drop-shadow-none rounded-xl">
        {!allWithdraws?.length ? (
          <p className="text-center  font-satoshi text-base text-dark">
            There is no withdraw created yet.
          </p>
        ) : (
          <WithdrawTable />
        )}
      </div>
      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
            }}
            label="Load more"
            className="h-10 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
            size="sm"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(WithdrawsScreen);
